import request from "@/utils/request";

const clientId = "86d5f7d840610860b2913b8cdbbc77f5";
// const PcClienId ="86d5f7d840610860b2913b8cdbbc77f5";
const grantType = "account_mobile";
export async function loginCheck(username, password, code, randomStr) {
  return request({
    url: "/auth/authentication/login",
    headers: {
      isToken: false,
      Authorization: "Basic aXR1emhpOml0dXpoaQ==",
    },
    method: "post",
    params: { username, password, randomStr, code, grantType, clientId },
  });
}

export async function refreshToken(refreshToken) {
  const grantType = "refresh_token";
  return request({
    url: "/auth/authentication/login",
    headers: {
      noToken: true,
      Authorization: "Basic aXR1emhpOml0dXpoaQ==",
    },
    method: "post",
    params: { refreshToken, grantType, clientId },
  });
}

export async function getUserInfo() {
  return request({
    url: "/parcel-cms/pc-user/info",
    method: "get",
  });
}

// 获取手机验证码
export async function GetPhoneCode(phone){
    return request({
      url:"/parcel-cms/note/code",
      method:"post",
      params:{phone}
    })
}
// 手机号码登录
export async function PhoneLogin(data){
  return request({
    url:"/parcel-cms/third/pc-login",
    method:"post",
    headers: {
      noToken: true,
    },
    params:data
  })
}

export async function UserRegister(data){
   return request({
      url:"/parcel-cms/third/pc-register",
      headers: {
        noToken: true,
      },
      method:"post",
      params:data
   })
}
// 用户修改信息
export async function UserChange(data){
   return request({
    url:"/parcel-cms/pc-user/edit",
    method:"post",
    data:data
   })
}
// 用户修改密码
export async function PassWordChange(data){
  return request({
    url:"/parcel-cms/pc-user/edit-pwd",
    method:"post",
    data:data
   })
}
// 用户退出登录
export async function Logout(data){
   return request({
    url:"/auth/authentication/logout",
    method:"delete",
   })
}

